import styled, { css } from 'styled-components';
import { baseStyles, baseProps } from './base.style';
import { LegacyListItemChild } from './legacy-list-item-child.style';
import { containerStyles, containerProps } from './container.style';
import { breakpointStyles, border, getPropTypes } from './utils';

const hoverStyles = props =>
  props.onClick &&
  css`
    &:hover {
      background: ${props => props.theme.colors.background.secondary};
      cursor: pointer;
    }
  `;

export const LegacyListItem = styled.li<StyleProps>`
  ${baseStyles}
  ${containerStyles}
  ${border}
  ${hoverStyles}

  ${LegacyListItemChild} {
    border-bottom: 1px solid ${props => props.theme.colors.background.tertiary};
  }

  &:first-child {
    ${border}
    ${breakpointStyles(border)}

    ${LegacyListItemChild} {
      border-top: 1px solid ${props => props.theme.colors.background.tertiary};
    }
  }

  &:last-child {
    ${border}
    ${breakpointStyles(border)}
  }

  ${breakpointStyles(baseStyles)}
  ${breakpointStyles(containerStyles)}
  ${breakpointStyles(border)}
`;

export const listProps = {
  ...baseProps,
  ...containerProps,
};

LegacyListItem.propTypes = getPropTypes(listProps);

LegacyListItem.defaultProps = {
  alignItems: 'center',
  flex: true,
  justifyContent: 'space-between',
  padding: {
    bottom: '24px',
    top: '24px',
  },
  width: '100%',
};
